var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-position":_vm.labelPosition,"label-width":(_vm.width + "em"),"size":"mini","inline":_vm.inline}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }